import { render, staticRenderFns } from "./EditPayPassword.vue?vue&type=template&id=f16dc348&scoped=true"
import script from "./EditPayPassword.vue?vue&type=script&lang=js"
export * from "./EditPayPassword.vue?vue&type=script&lang=js"
import style0 from "./EditPayPassword.vue?vue&type=style&index=0&id=f16dc348&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16dc348",
  null
  
)

export default component.exports